const initialState = {
  code: '',
  treeData: [],
};

export function setTreeDepart(payload) {
  return {
    type: 'SELECTDEPART',
    payload,
  };
}

export function setDepartments(payload) {
  return {
    type: 'SETDEPART',
    payload,
  };
}

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SELECTDEPART': {
      return Object.assign({}, state, { code: payload });
    }
    case 'SETDEPART': {
      return Object.assign({}, state, { treeData: payload });
    }
    default:
      return state;
  }
};
